import { AxiosInstance } from 'axios'

import { ProvisionHighlight } from '@dc-shared-web/hooks/api/annotations/types'

type GetProvisionHighlightsResponse = {
  limit: number
  page: number
  total: number
  totalpages: number
  results: ProvisionHighlight[]
}

type GetProvisionHighlightsParams = {
  crunchUUID?: string
  includeDeleted?: boolean
  enabled?: boolean
}

const BATCH_SIZE = 1000

export const fetchProvisionHighlights = async (
  apiClient: AxiosInstance,
  params: GetProvisionHighlightsParams
): Promise<ProvisionHighlight[]> => {
  if (!params.crunchUUID) {
    return []
  }

  const result: ProvisionHighlight[] = []
  let currentPage = 1
  let data: GetProvisionHighlightsResponse

  do {
    const { data: response } =
      await apiClient.get<GetProvisionHighlightsResponse>(
        `/api/crunch/${params.crunchUUID}/provision-highlights`,
        {
          params: {
            page: currentPage,
            limit: BATCH_SIZE,
            withDeleted: params.includeDeleted,
          },
        }
      )

    result.push(...response.results)

    data = response
    currentPage += 1
  } while (result.length < data.total)

  return result
}
